import { Command } from "./Command";
import { GamePlay } from "../model/game-play";
import { ODK } from "../model/odk";
import { PlayResult } from "../model/playResult";

export class SetGainCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private gain: number
  ) { }

  execute() {
    console.log('COMMAND SetGainCommand', this.gain)

    if (this.gamePlay.odk === ODK.Kick) {
      if (this.isSafety()) {
        this.gamePlay.gnLs = this.gain
      } else {
        // Sébas : Sur les kickoffs c’est pas obligatoire de mettre le gn/ls on calcul le return yard dans les stats
        this.gamePlay.gnLs = 0
      }
    } else {
      this.gamePlay.gnLs = this.gain
    }
  }

  private isSafety() {
    return [PlayResult.Safety].includes(this.gamePlay.result!);
  }
}
